export default "__VITE_ASSET__CbCZynD3__"